/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Promotion,
    PromotionFromJSON,
    PromotionFromJSONTyped,
    PromotionToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedPromotionList
 */
export interface PaginatedPromotionList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPromotionList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPromotionList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPromotionList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Promotion>}
     * @memberof PaginatedPromotionList
     */
    results?: Array<Promotion>;
}

export function PaginatedPromotionListFromJSON(json: any): PaginatedPromotionList {
    return PaginatedPromotionListFromJSONTyped(json, false);
}

export function PaginatedPromotionListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedPromotionList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(PromotionFromJSON)),
    };
}

export function PaginatedPromotionListToJSON(value?: PaginatedPromotionList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(PromotionToJSON)),
    };
}


